<template>
  <div>
    <b-row>
      <b-col>
        <b-overlay :show="isLoading" rounded="sm" :opacity="0.7">
          <div v-show="errors.length > 0" class="alert-danger">
            <h4>خطا:</h4>
            <ul v-bind:key="index" v-for="(error, index) in errors">
              <li>{{ error }}</li>
            </ul>
          </div>

          <b-form @submit.prevent="save">
            <div>
              <Search
                v-if="case_evidenceUrl"
                :url="case_evidenceUrl + '?is_enable='"
                ref="indicator_search"
                :title="$lang.indicator"
                :allowFields="$lang.template_indicator_fields"
                config="template_competency_indicator"
                addModalSize="lg"
                removeModalSize="xl"
                :visibleSearch="false"
                :visibleSettings="false"
                :visibleExport="false"
                :visibleFilters="false"
                :visibleViewCount="false"
                :allowEdit="false"
                :allowRemove="false"
                :visibleAdd="false"
                :dynamicButtons="buttons"
              />

              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="view_edit_CenterExecuteCaseEvidence"
                size="lg"
                ok-only
                hide-footer
                hide-header
              >
                <EditCenterExecuteCaseEvidence
                  :isModal="true"
                  :entityId="[
                    center_execute_id,
                    case_id,
                    indicator_id,
                    indicator_name,
                    template_id,
                    exercise_id,
                    competency_id,
                  ]"
                  @modal-end-up="closeEditCenterExecuteCaseEvidence"
                />
              </b-modal>

              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="view_history_CenterExecuteCaseEvidence"
                size="xl"
                ok-only
                hide-footer
                @close="closeHistoryCenterExecuteCaseEvidence"
              >
                <Search
                  :title="
                    $lang.search.center_execute_case_evidence_history_tooltip
                  "
                  v-if="case_evidenceUrl"
                  :url="evidence_url + '?is_enable=0'"
                  :allowFields="$lang.center_execute_case_evidence_fields"
                  ref="history_centerExecuteCaseEvidence_search"
                  config="center_execute_case_evidence"
                  :visibleSearch="false"
                  :visibleSettings="false"
                  :visibleExport="false"
                  :visibleFilters="false"
                  :visibleViewCount="false"
                  :allowEdit="false"
                  :allowRemove="false"
                  :visibleAdd="false"
                  :allowOperate="false"
                />
              </b-modal>
            </div>
            <b-row>
              <b-col cols="12" sm="12" md="4" xl="4">
                <b-form-group
                  :label="$lang.score"
                  label-for="score"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.score"
                    :rules="$v.score.$params"
                  />
                  <b-form-input
                    id="score"
                    type="number"
                    :autocomplete="$lang.score"
                    :state="$v.score.$dirty ? !$v.score.$error : null"
                    v-model="$v.score.$model"
                  ></b-form-input>
                  <b-form-invalid-feedback
                    v-if="!$v.score.required"
                    id="score-feedback"
                    >{{
                      $lang.error_required | replace($lang.score)
                    }}</b-form-invalid-feedback
                  >
                  <b-form-invalid-feedback
                    v-if="
                      $v.score.required &&
                      !$v.score.minValue | !$v.score.maxValue
                    "
                    id="score-feedback"
                    >{{
                      $lang.error_Value | replace($lang.score, 5, 0)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="12" md="8" xl="8">
                <b-form-group
                  :label="$lang.description"
                  label-for="description"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.description"
                    :rules="$v.description.$params"
                  />
                  <b-form-textarea
                    id="description"
                    :state="
                      $v.description.$dirty ? !$v.description.$error : null
                    "
                    v-model="$v.description.$model"
                    type="text"
                    :autocomplete="$lang.description"
                    :rows="this.$config.form.textareaRows"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="description-feedback">{{
                    $lang.error_required | replace($lang.description)
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button class="ml-2" size="md" variant="danger" @click="cancel">
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import EditCenterExecuteCaseEvidence from "../center_execute_case_evidence/editCenterExecuteCaseEvidence";
import {
  required,
  numeric,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";

export default {
  name: "edit-center_execute_case_competency",
  validations: {
    score: {
      required,
      minValue: minValue(0),
      maxValue: maxValue(5),
      numeric,
    },
    description: {},
  },
  components: {
    Search,
    EditCenterExecuteCaseEvidence,
  },
  props: {
    backUrl: {
      type: String,
      default: "",
    },
    center_execute_id: {
      type: Number,
      required: true,
    },
    case_id: {
      type: Number,
      required: true,
    },
    competency_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      errors: [],
      exercise_id: "",
      assessment_plan_name: "",
      competency_name: "",
      status: null,
      company_name: "",
      template_name: "",
      assessor: "",
      candidate: "",
      indicator_id: "",
      indicator_name: "",
      exercise_name: "",
      template_id: "",
      execute_id: "",
      url_get_exercise: "",
      score: "",
      description: "",
      view_edit_CenterExecuteCaseEvidence: false,
      view_history_CenterExecuteCaseEvidence: false,
      isLoading: false,
      case_evidenceUrl: "",
      buttons: [
        {
          id: 0,
          name: "evidence",
          click: this.showEditCenterExecuteCaseEvidence,
        },
        {
          id: 1,
          name: "viewHistory",
          click: this.showHistoryCenterExecuteCaseEvidence,
        },
      ],
      evidence_url:
        this.$config.api_url + this.$config.kanoon.center_execute_case_evidence,
    };
  },
  methods: {
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
        // this.handleBack();
      } else {
        this.$emit("end");
      }
    },
    ok(item) {
      this.$emit("ok", item);
    },
    cancel() {
      this.$emit("cancel");
    },
    clear() {
      this.name = "";
      this.description = "";
    },
    changes() {},
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    closeEditCenterExecuteCaseEvidence() {
      this.view_edit_CenterExecuteCaseEvidence = false;

      this.$refs.indicator_search.getItems();
    },
    showEditCenterExecuteCaseEvidence(item) {
      this.indicator_id = item.indicator_object.id;
      this.indicator_name = item.indicator;
      this.view_edit_CenterExecuteCaseEvidence = true;
    },
    closeHistoryCenterExecuteCaseEvidence() {
      this.evidence_url =
        this.$config.api_url + this.$config.kanoon.center_execute_case_evidence;
      this.view_history_CenterExecuteCaseEvidence = false;
      this.$refs.history_centerExecuteCaseEvidence_search.getItems();
    },
    showHistoryCenterExecuteCaseEvidence(item) {
      this.evidence_url = this.evidence_url
        .replace("{0}", item.case_object.center_execute_id)
        .replace("{1}", item.case_object.id)
        .replace("{2}", item.template_competency_indicator_exercise_object.id);
      this.view_history_CenterExecuteCaseEvidence = true;
    },
    save() {
      this.isLoading = true;
      this.$v.$touch();
      if (this.$v.$anyError) {
        this.isLoading = false;
        return;
      }

      let payload = {
        score: this.score,
        description: this.description,
      };
      this.$httpService
        .put(
          this.$config.api_url +
            this.$config.kanoon.center_execute_case_competency
              .replace("{0}", this.center_execute_id)
              .replace("{1}", this.case_id) +
            "/" +
            this.competency_id,
          payload
        )
        .then((response) => {
          this.$notify.success(response.data.message);

          this.ok(payload);
          //this.afterSave();
        })
        .catch((err) => {
          if (err.response.status === 400) {
            if (typeof err.response.data.message === "object") {
              err.response.data.message.forEach((element) => {
                this.errors.push(element);
              });
            } else {
              this.$notify.error(err.response.data.message);
            }
          } else {
            this.$notify.error(err.message);
          }

          this.isLoading = false;
        });
    },
    fetchData() {
      if (
        isNaN(this.center_execute_id) ||
        isNaN(this.case_id) ||
        isNaN(this.competency_id)
      ) {
        this.$notify.error("Not a number!");
        return false;
      }

      return this.$httpService
        .get(
          this.$config.api_url +
            this.$config.kanoon.center_execute_case_competency
              .replace("{0}", this.center_execute_id)
              .replace("{1}", this.case_id) +
            "/" +
            this.competency_id +
            "?is_enable=1"
        )
        .then((response) => {
          let data = response.data.data;

          if (!data || data.length == 0) {
            return false;
          }
          this.assessment_plan_name =
            data.center_execute_case.center_execute.assessment_plan
              .candidate_count +
            " " +
            this.$lang.candidate +
            " " +
            data.center_execute_case.center_execute.assessment_plan
              .assessor_count +
            " " +
            this.$lang.assessor +
            " " +
            data.center_execute_case.center_execute.assessment_plan.room_count +
            " " +
            this.$lang.room;
          this.template_name =
            data.center_execute_case.center_execute.assessment_plan.template.caption;
          this.template_id =
            data.center_execute_case.center_execute.assessment_plan.template.id;
          this.company_name =
            data.center_execute_case.center_execute.company.name;

          this.assessor = "-";
          if (data.center_execute_case.assessor !== null) {
            this.assessor =
              data.center_execute_case.assessor.person.name +
              " " +
              data.center_execute_case.assessor.person.family;
          }

          this.candidate =
            data.center_execute_case.candidate.person.name +
            " " +
            data.center_execute_case.candidate.person.family;
          this.competency_id = data.competency.id;
          this.competency_name = data.competency.name;
          this.exercise_name =
            data.center_execute_case.exercise_algorithm.exercise.name;
          this.exercise_id =
            data.center_execute_case.exercise_algorithm.exercise_id;

          this.url_get_exercise =
            this.$config.api_url +
            this.$config.kanoon.template_exercise
              .replace("{0}", this.template_id)
              .replace("{1}", this.exercise_id);

          this.score = data.score;

          this.status = this.$lang.pending;
          if (data.status === 2) {
            this.status = this.$lang.confirmed;
          }
          this.description = data.description;

          this.isLoading = false;

          this.case_evidenceUrl =
            this.$config.api_url +
            this.$config.kanoon.center_execute_case_evidences_by_competency
              .replace("{0}", this.center_execute_id)
              .replace("{1}", this.case_id)
              .replace("{2}", this.competency_id);
          return true;
        })
        .catch((err) => {
          // this.$notify.error(err.response.data.message);
          throw err;
        });
    },
  },
  watch: {},
  created() {
    this.isLoading = true;
    this.fetchData()
      .then((x) => {
        if (!x) {
          this.$notify.error(this.$lang.data_not_exist);
          this.handleBack();
        }
      })
      .finally(() => (this.isLoading = false));
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}
</style>
